'use strict';

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _themeSections = require('@shopify/theme-sections');

var _themeCurrency = require('@shopify/theme-currency');

var _themeCart = require('@shopify/theme-cart');

var cart = _interopRequireWildcard(_themeCart);

var _cssClasses = require('../helpers/cssClasses');

var _cssClasses2 = _interopRequireDefault(_cssClasses);

var _svgMap = require('../helpers/svg-map');

var _toggle = require('../components/toggle');

var _toggle2 = _interopRequireDefault(_toggle);

var _quantitySelector = require('../components/quantity-selector');

var _quantitySelector2 = _interopRequireDefault(_quantitySelector);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * DOM selectors.
 */
/**
 * Section: Cart drawer
 * -----------------------------------------------------------------------------
 * Contains highly coupled scripts to render cart items onto a drawer.
 *
 * @namespace cartDrawer
 */
var selectors = {
  body: '[js-cart-drawer="body"]',
  footer: '[js-cart-drawer="footer"]',
  subtotal: '[js-ajax-cart="subtotal"]',
  quantitySelector: '[js-ajax-cart="quantitySelector"]',
  lineItem: '[js-ajax-cart="lineItem"]'
};

/**
 * Instance globals.
 */
var timer = {};

/**
 * Create a new drawer instance.
 */
var Drawer = (0, _toggle2.default)({
  toggleSelector: 'cartDrawerToggle',
  targetSelector: 'cartDrawerTarget',
  overlay: false
});

/**
 * Register the `cart-drawer` section type.
 */
(0, _themeSections.register)('cart-drawer', {

  /**
   * Initialise section.
   */
  init: function init() {
    Drawer.init();
    this.body = document.querySelector(selectors.body);
    this.footer = document.querySelector(selectors.footer);
    this.subtotal = document.querySelector(selectors.subtotal);
  },


  /**
   * Set listeners for each instance.
   */
  setListeners: function setListeners() {
    var _this = this;

    Frame.EventBus.listen('Toggle:cartDrawerTarget:open', function () {
      return _this.render();
    });
    Frame.EventBus.listen('AjaxCart:itemAdded', function () {
      return _this.open();
    });
    Frame.EventBus.listen(['AjaxCart:cartCleared', 'AjaxCart:itemRemoved'], function () {
      return _this.render();
    });
    Frame.EventBus.listen(['AjaxCart:removingItem'], function (item) {
      return _this.setLoadingState(item);
    });
  },


  /**
   * Render line items template.
   */
  render: function render() {
    var _this2 = this;

    _axios2.default.get('/cart.js').then(function (response) {
      if (response.data.item_count > 0) {
        _this2.setActiveState(response.data);
        _this2.constructQuantitySelectors();
        return;
      }

      _this2.setEmptyState();
      throw new Error('Cart is empty');
    }).catch(function (error) {
      return error;
    });
  },


  /**
  * Set active state.
  * @param {object} data - Cart data.
  */
  setActiveState: function setActiveState(data) {
    this.body.innerHTML = this.getActiveTemplate(data.items);
    this.subtotal.innerHTML = (0, _themeCurrency.formatMoney)(data.total_price, theme.moneyFormat);
    this.footer.classList.remove(_cssClasses2.default.hidden);
    Frame.EventBus.emit('AjaxCart:reinit');
  },


  /**
   * Set loading state.
   * @param {object} element - DOM line item.
   */
  setLoadingState: function setLoadingState(element) {
    element.classList.add(_cssClasses2.default.removing);
  },


  /**
  * Set empty state.
  */
  setEmptyState: function setEmptyState() {
    this.body.innerHTML = this.getEmptyTemplate();
    this.footer.classList.add(_cssClasses2.default.hidden);
  },


  /**
  * Get cart drawer body template.
  * @param {Object} items - Cart line item object data.
  * @returns {string} - Template string.
  */
  getActiveTemplate: function getActiveTemplate(items) {
    var _this3 = this;

    return items.map(function (item, index) {
      return _this3.getLineItemTemplate(item, index);
    }).join('');
  },


  /**
   * Get empty cart template.
   */
  getEmptyTemplate: function getEmptyTemplate() {
    return '<p>' + theme.strings.cart.general.empty + '</p>';
  },


  /**
   * Get line item template.
   * @param {Object} item - Cart line item object data.
   * @returns {string} - Template.
   */
  getLineItemTemplate: function getLineItemTemplate(item, index) {
    if (item.id !== window.theme.giftWrap.id) {
      return '\n        <div class="ajax-cart__line-item" js-ajax-cart="lineItem" data-key="' + item.key + '">\n          <div class="ajax-cart__image responsive-image__wrapper">\n            <img \n              src="' + item.image + '"\n              srcset="' + item.image + ' 300w, ' + item.image + ' 700w, ' + item.image + ' 1000w"\n              alt="' + item.title + '"\n            >\n          </div>\n\n          <div class="ajax-cart__description">\n            <div class="row">\n              <div class="col s12">\n                <a class="ajax-cart__title h6" href="' + item.url + '">' + item.product_title + '</a>\n\n                <div class="row">\n                  <div class="col s12 m12">\n                    <div data-label="Price">\n                      <s id="cap-' + item.key + '"></s>\n                      ' + this.getLineItemPrice(item) + '                      \n                    </div>\n                  </div>\n                  <div class="col s12 m12">\n                    ' + this.getVariantTitle(item) + '\n\n                    <div class="ajax-cart__quantity-selector" data-label="Quantity">\n                      <label for="Quantity-' + index + '" class="label visually-hidden">Quantity</label>\n                      <div id="QuantitySelector-' + index + '" class="quantity-selector quantity-selector--small" js-ajax-cart="quantitySelector">\n                        <div class="quantity-selector__control">\n                          <button class="button quantity-selector__button" js-quantity-selector="decrement" value="decrement">\n                            ' + _svgMap.misc.minus + '\n                            <span class="visually-hidden">-</span>\n                          </button>\n                        </div>\n                      \n                        <div class="quantity-selector__control">\n                          <input type="number" id="Quantity-' + index + '" name="quantity" value="' + item.quantity + '" min="1" pattern="[0-9]*" class="quantity-selector__input" js-quantity-selector="input" readonly />\n                        </div>\n                      \n                        <div class="quantity-selector__control">\n                          <button class="button quantity-selector__button" js-quantity-selector="increment" value="increment">\n                            ' + _svgMap.misc.plus + '\n                            <span class="visually-hidden">+</span>\n                          </button>\n                        </div>\n                      </div>\n                    </div>\n\n                    <p><small class="ajax-cart__remove" js-ajax-cart="remove" data-key="' + item.key + '" tabindex="0">Remove</small></p>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      ';
    }
  },


  /**
   * Get variant titles.
   * @param {Object} items - Cart line item object data.
   * @returns {string}
   */
  getVariantTitle: function getVariantTitle(item) {
    return this.isVariantTitle(item) ? '<p class="meta">SIZE: ' + item.variant_title + '</p>' : '';
  },


  /**
   * Check if variant title exists.
   * @param {object} item - Cart line item object data.
   */
  isVariantTitle: function isVariantTitle(item) {
    return item.variant_options.length && !item.variant_options[0].includes('Default Title');
  },


  /**
   * Get variant titles.
   * @param {Object} items - Cart line item object data.
   * @returns {string}
   */
  getLineItemPrice: function getLineItemPrice(item) {
    return item.properties && item.properties._compare_at_price > item.line_price ? '<s>' + (0, _themeCurrency.formatMoney)(item.properties._compare_at_price, theme.moneyFormat) + '</s> ' + (0, _themeCurrency.formatMoney)(item.line_price, theme.moneyFormat) : '' + (0, _themeCurrency.formatMoney)(item.line_price, theme.moneyFormat);
  },


  /**
  * Instantiate quantity selectors using id.
  * - Callback has a timer to reduce number of calls.
  */
  constructQuantitySelectors: function constructQuantitySelectors() {
    var _this4 = this;

    var quantitySelectors = document.querySelectorAll(selectors.quantitySelector);

    [].concat((0, _toConsumableArray3.default)(quantitySelectors)).forEach(function (item) {

      (0, _quantitySelector2.default)('' + item.id, function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          _this4.handleQuantityEvent(item);
        }, 250);
      }).init();
    });
  },


  /**
   * Handle quantity updates.
   * @param {HTMLElement} element - Quantity selector node element.
   */
  handleQuantityEvent: function handleQuantityEvent(element) {
    var _this5 = this;

    var data = {
      key: element.closest(selectors.lineItem).dataset.key,
      quantity: parseInt(element.querySelector('input').value, 10)
    };

    cart.updateItem(data.key, { quantity: data.quantity }).then(function (response) {
      _this5.render();
      Frame.EventBus.emit('AjaxCart:itemUpdated');
      return response;
    }).catch(function (error) {
      return error;
    });
  },


  /**
   * Open drawer and force render.
   */
  open: function open() {
    Drawer.open();
    this.render();
  },


  /**
   * Callback function when section is loaded via 'sections.load()' or by the Theme Editor 'shopify:section:load' event.
   */
  onLoad: function onLoad() {
    this.init();
    this.setListeners();
  }
});